import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";

function initSlideshows() {
  document.querySelectorAll(".slideshow").forEach((el) => {
    if (el.dataset.swiperInit) return;
    el.dataset.swiperInit = "true";

    new Swiper(el, {
      modules: [Autoplay, EffectFade],
      effect: "fade",
      fadeEffect: { crossFade: true },
      loop: true,
      speed: 1200,
      slidesPerView: 1,
      allowTouchMove: false,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    });
  });
}

if (document.readyState !== "loading") {
  initSlideshows();
} else {
  document.addEventListener("DOMContentLoaded", initSlideshows);
}
